module.exports = __webpack_public_path__ + "static/media/sp_close.c5739290.svg";